import React from 'react';
import { useTranslation } from 'react-i18next';

const COLOR_BY_LABEL = {
  SANDBOX: 'bg-amber-100 text-amber-800 border-amber-200',
  PROD: 'bg-red-100 text-red-800 border-red-200',
  PRODUCTION: 'bg-red-100 text-red-800 border-red-200',
  STAGING: 'bg-blue-100 text-blue-800 border-blue-200',
};

const DEFAULT_COLOR = 'bg-gray-100 text-gray-700 border-gray-200';

export default function EnvironmentBadge() {
  const { t } = useTranslation(['ui']);
  const raw = (process.env.REACT_APP_ENVIRONMENT_LABEL || '').trim();
  if (!raw) return null;
  const label = raw.toUpperCase();
  const colorClass = COLOR_BY_LABEL[label] || DEFAULT_COLOR;
  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 text-xs font-semibold rounded border ${colorClass}`}
      aria-label={`${t('ui:header.environment')}: ${label}`}
      title={`${t('ui:header.environment')}: ${label}`}
    >
      {label}
    </span>
  );
}
